import AjaxUtils from "../../../util/ajax_utils";
import {ApckPortletTable} from "../portlet";

export const ApckPortletMyVulns = /*#__PURE__*/ ApckPortletTable.extend({
    props: {
        ctype: {
            type: String,
            default: "myvulnsportlet"
        },
        title: {
            type: String,
            default: "My Vulnerabilities"
        },
        size: {
            type: String,
            default: "lg"
        },
        description: {
            type: String,
            default: "Vulnerabilities assigned to me"
        },
        src: {
            type: String,
            default: "/myvulns"
        },
        limit: {
            type: Number,
            default: 20
        },
        sglRowAction: {
            type: Function,
            default: function (rec) {
                if (this.$globalFlags.spa) {
                    return this.$router.push({
                        name: 'vulnerabilities.view',
                        params: {
                            vulnerability_id: rec.get('_id')
                        }
                    });
                } else {
                    window.open(`/vulnerabilities/${rec.get('_id')}`, '_blank').focus();
                }
            },
        },
        cols: {
            type: Array,
            default: () => [
                {heading: 'Name', data: 'title'},
                {heading: 'Modified', ctype: 'datecolumn', data: 'modified', width: 150},
            ]
        },
        tableOptions: {
            type: Object,
            default: function () {
                return {
                    actionBtnWidth: 86,
                }
            }
        }
    },
    data: function () {
        return {
            table_actions: [
                {
                    title: "Mark as Fixed",
                    value: "Fixed",
                    class: "btn-primary",
                    handler: (row) => this.setVulnStatus(row, "fixed"),
                }, {
                    title: "Mark as Acceptable Risk",
                    value: "Acceptable Risk",
                    class: "btn-secondary",
                    handler: (row) => this.setVulnStatus(row, "acceptable_risk")
                }, {
                    title: "Mark as False Positive",
                    value: "False Positive",
                    class: "btn-neutral",
                    handler: (row) => this.setVulnStatus(row, "false_positive")
                }
            ],
        }
    },
    methods: {
        setVulnStatus(vuln, new_status) {
            const cmp = this;

            AjaxUtils.ajax_post({
                url: "/vulnerabilities/bulk_status",
                data: {
                    status: new_status,
                    checked: [vuln.get("_id")]
                },
                success: function (json, status, xhr) {
                    cmp.manual_refresh();
                },
                opts: {
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8"
                }
            })

        }
    },
});
